var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2928 4.70843C8.00741 4.42296 7.93065 4.00782 8.0625 3.65259L8.1647 3.45109C8.2013 3.39564 8.244 3.34303 8.2928 3.29422L8.29281 3.29421L8.2949 3.29212L10.4134 1.1729C10.8038 0.782373 11.4368 0.782374 11.8272 1.1729C12.2176 1.56342 12.2176 2.19659 11.8272 2.58711L11.3988 3.01568C13.9738 3.21887 16 5.37282 16 8.00002C16 10.7614 13.7614 13 11 13L10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11L11 11C12.6569 11 14 9.65687 14 8.00002C14 6.4942 12.8906 5.24751 11.4445 5.03272L11.8272 5.41553C12.2176 5.80605 12.2176 6.43922 11.8272 6.82974C11.4368 7.22027 10.8038 7.22027 10.4134 6.82974L8.29635 4.71196L8.2928 4.70843ZM7.7072 11.2942C7.99258 11.5797 8.06935 11.9948 7.9375 12.3501L7.8353 12.5516C7.7987 12.607 7.756 12.6596 7.7072 12.7084L7.70719 12.7084L7.7051 12.7105L5.58656 14.8298C5.19616 15.2203 4.56319 15.2203 4.1728 14.8298C3.7824 14.4392 3.7824 13.8061 4.17279 13.4155L4.60366 12.9845C2.02752 12.7825 0 10.628 0 8.00002C0 5.23859 2.23858 3.00001 5 3.00001H6C6.55228 3.00001 7 3.44773 7 4.00001C7 4.5523 6.55228 5.00002 6 5.00002H5C3.34315 5.00002 2 6.34316 2 8.00002C2 9.50476 3.10784 10.7507 4.55239 10.9668L4.17279 10.5871C3.78239 10.1966 3.78239 9.56344 4.17279 9.17291C4.56319 8.78239 5.19615 8.78239 5.58655 9.17291L7.70365 11.2907L7.7072 11.2942Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.9dc00dac51c4d87544a864b3b6bd1eb1.svg";
export { ForwardRef as ReactComponent };